import React from "react"
import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view"

export default function FieldProgress_QuickFilterView(props: FieldQuickFilterViewProps) {

    const label = (props.value !== null && props.value !== undefined && props.value !== 'null')
        ? `${props.value}%`
        : 'Not set'

    const classes = Classes("ui5-group-by-view", props.className)

    return (
        <div className={classes}>
            <div className="name">{label}</div>
        </div>
    )
}
